import { createClient } from '@supabase/supabase-js';

// This file initializes the Supabase client.

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Seems like okay use of ! here as the two variables won't be null
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
